export const SET_UI_AS_LOADED = 'UI_SETTINGS_SET_UI_AS_LOADED'
export const SAVE_ALL_UI = 'UI_SETTINGS_SAVE_ALL'
export const SET_LAUNCH_DELAY = 'UI_SETTINGS_SET_LAUNCH_DELAY'
export const SET_AUTO_LAUNCH_ON_LOGIN = 'UI_SETTINGS_SET_AUTO_LAUNCH_ON_LOGIN'
export const SET_AUTO_LAUNCH_ON_STARTUP = 'SET_AUTO_LAUNCH_ON_STARTUP'
export const SET_LAYOUT = 'UI_SETTINGS_SET_LAYOUT'



// WEBPACK FOOTER //
// ./src/features/Settings/data/ui/constants.js